import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setDefaultEventParameters,
  setUserProperties
} from "firebase/analytics";
import { firebaseConfig } from './firebase/config';
import { ThemeModeProvider } from './themeMode';
import { getAppEntryAttribution } from './analytics/entryAttribution';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const entryAttribution = getAppEntryAttribution({
  search: window.location.search,
  referrer: document.referrer
});

// Keep the modern and legacy experiences distinguishable even though they use
// the same Firebase Analytics property. Default parameters apply to every
// event emitted by the app, while the user property makes audience/report
// segmentation straightforward in GA4.
setDefaultEventParameters({
  ui_version: 'new',
  app_surface: 'web_app',
  ...entryAttribution
});
setUserProperties(analytics, { ui_version: 'new' });
logEvent(analytics, 'experience_loaded', {
  ui_version: 'new',
  ...entryAttribution
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <Router>
        <App />
      </Router>
    </ThemeModeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
